import { isMobileLayout } from '@/shared/composables/use-mobile'
import { useSidebar } from '@/shared/composables/use-sidebar'

const { isOpenSidebarMenu, closeSidebar, shouldSkipMobileAsideClose } = useSidebar()

export const closeAside = () => {
  if (shouldSkipMobileAsideClose()) {
    return
  }

  if (isMobileLayout.value && isOpenSidebarMenu.value) {
    closeSidebar()
  }
}
